import React from 'react'

import Base from '../_Base'

const ExternalLink = (props) => (
  <Base width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M7,2 C7.552,2 8,2.448 8,3 C8,3.552 7.552,4 7,4 L7,4 L4,4 L4,12 L12,12 L12,9 C12,8.448 12.447,8 13,8 C13.553,8 14,8.448 14,9 L14,9 L14,13 C14,13.553 13.553,14 13,14 L13,14 L3,14 C2.448,14 2,13.553 2,13 L2,13 L2,3 C2,2.448 2.448,2 3,2 L3,2 Z M13.0684,2 C13.5834,2 14.0004,2.417 14.0004,2.932 L14.0004,2.932 L14.0004,5.533 C14.0004,5.948 13.4984,6.156 13.2054,5.863 L13.2054,5.863 L12.3784,5.036 L8.7074,8.707 C8.5114,8.902 8.2564,9 8.0004,9 C7.7444,9 7.4884,8.902 7.2934,8.707 C6.9024,8.316 6.9024,7.684 7.2934,7.293 L7.2934,7.293 L10.9644,3.622 L10.1374,2.795 C9.8434,2.502 10.0514,2 10.4664,2 L10.4664,2 Z"></path>
  </Base>
)

export default ExternalLink
